import createIcon from '../../createIcon';

/**
 * @component @name TheaterComedy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxNkMyIDE5LjA0IDQuNDYgMjEuNSA3LjUgMjEuNUMxMC41NCAyMS41IDEzIDE5LjA0IDEzIDE2VjkuNUgyVjE2Wk03LjUgMThDNi4xMiAxOCA1IDE3LjMzIDUgMTYuNUgxMEMxMCAxNy4zMyA4Ljg4IDE4IDcuNSAxOFpNMTAgMTIuNUMxMC41NSAxMi41IDExIDEyLjk1IDExIDEzLjVDMTEgMTQuMDUgMTAuNTUgMTQuNSAxMCAxNC41QzkuNDUgMTQuNSA5IDE0LjA1IDkgMTMuNUM5IDEyLjk1IDkuNDUgMTIuNSAxMCAxMi41Wk01IDEyLjVDNS41NSAxMi41IDYgMTIuOTUgNiAxMy41QzYgMTQuMDUgNS41NSAxNC41IDUgMTQuNUM0LjQ1IDE0LjUgNCAxNC4wNSA0IDEzLjVDNCAxMi45NSA0LjQ1IDEyLjUgNSAxMi41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExIDIuNVY4LjVIMTRWMTFDMTQgMTAuMTcgMTUuMTIgOS41IDE2LjUgOS41QzE3Ljg4IDkuNSAxOSAxMC4xNyAxOSAxMUgxNFYxMy44OUMxNC43NSAxNC4yNyAxNS42IDE0LjUgMTYuNSAxNC41QzE5LjU0IDE0LjUgMjIgMTIuMDQgMjIgOVYyLjVIMTFaTTE0IDcuNThDMTMuNDUgNy41OCAxMyA3LjEzIDEzIDYuNThDMTMgNi4wMyAxMy40NSA1LjU4IDE0IDUuNThDMTQuNTUgNS41OCAxNSA2LjAzIDE1IDYuNThDMTUgNy4xNCAxNC41NSA3LjU4IDE0IDcuNThaTTE5IDcuNThDMTguNDUgNy41OCAxOCA3LjEzIDE4IDYuNThDMTggNi4wMyAxOC40NSA1LjU4IDE5IDUuNThDMTkuNTUgNS41OCAyMCA2LjAzIDIwIDYuNThDMjAgNy4xNCAxOS41NSA3LjU4IDE5IDcuNThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TheaterComedy = createIcon('TheaterComedy', [
  [
    'path',
    {
      d: 'M2 16C2 19.04 4.46 21.5 7.5 21.5C10.54 21.5 13 19.04 13 16V9.5H2V16ZM7.5 18C6.12 18 5 17.33 5 16.5H10C10 17.33 8.88 18 7.5 18ZM10 12.5C10.55 12.5 11 12.95 11 13.5C11 14.05 10.55 14.5 10 14.5C9.45 14.5 9 14.05 9 13.5C9 12.95 9.45 12.5 10 12.5ZM5 12.5C5.55 12.5 6 12.95 6 13.5C6 14.05 5.55 14.5 5 14.5C4.45 14.5 4 14.05 4 13.5C4 12.95 4.45 12.5 5 12.5Z',
      key: 'ej9oz3',
    },
  ],
  [
    'path',
    {
      d: 'M11 2.5V8.5H14V11C14 10.17 15.12 9.5 16.5 9.5C17.88 9.5 19 10.17 19 11H14V13.89C14.75 14.27 15.6 14.5 16.5 14.5C19.54 14.5 22 12.04 22 9V2.5H11ZM14 7.58C13.45 7.58 13 7.13 13 6.58C13 6.03 13.45 5.58 14 5.58C14.55 5.58 15 6.03 15 6.58C15 7.14 14.55 7.58 14 7.58ZM19 7.58C18.45 7.58 18 7.13 18 6.58C18 6.03 18.45 5.58 19 5.58C19.55 5.58 20 6.03 20 6.58C20 7.14 19.55 7.58 19 7.58Z',
      key: '18wcha',
    },
  ],
]);

export default TheaterComedy;
